import { TREND_TOOLS } from '@/toolSelection/investigate.constants';
import { type TemplateDehydratedState, TemplateStore } from '@/tools/models/template.store';
import type { TemplateOutputV1 } from '@seeqdev/api/model/TemplateOutputV1';

export type ToolTemplateDehydratedState = TemplateDehydratedState;

/**
 * Store for template within the tool pane.
 * Templates can be created and edited in multiple places (e.g. tool pane, scaling tables)
 * so we need a dedicated store for the template tool to avoid conflicts with other places.
 */
export class ToolTemplateStore extends TemplateStore {
  static readonly storeName = 'sqToolTemplateStore';

  override dehydrate(): ToolTemplateDehydratedState {
    return super.dehydrate();
  }

  override rehydrate(dehydratedState: Partial<ToolTemplateDehydratedState>): void {
    super.rehydrate(dehydratedState);
  }

  protected override readonly handlers = {
    ...this.baseHandlers,
    TOOL_MODEL_RESET_MODEL: this.resetTemplate,
    TOOL_MODEL_SET_MODEL: this.setTemplate,
    TOOL_MODEL_SET_FEATURE_TO_EDIT_ID: this.setFeatureToEditId,
    TOOL_MODEL_SET_INSTANCE_TO_EDIT_ID: this.setInstanceToEditId,
    TOOL_MODEL_SET_MODEL_OUTPUT: this.setTemplateOutput,
    TOOL_MODEL_SET_VERSION_STATE: this.setVersionState,
    TOOL_MODEL_SET_INSTANCE_COUNT: this.setInstanceCount,
    MODEL_TOOL_REHYDRATE_FOR_EDIT: (payload: { type: string; modelData: TemplateOutputV1; instanceId: string }) => {
      if (payload.type !== TREND_TOOLS.MODEL_APPLY) {
        return;
      }
      this.setTemplateOutput({ templateOutput: payload.modelData });
      this.setInstanceToEditId({ instanceToEditId: payload.instanceId });
    },
  };
}
